import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=7a053cc8&"
import script from "./LateralMenu.vue?vue&type=script&lang=ts&"
export * from "./LateralMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports